<rd-popup-default-template
  [dialogContent]="dialogContent"
  [showCloseButton]="false"
  [showButtons]="true"
  [showSecondaryButton]="false"
  [primaryButtonText]="'wl.star.notice_modal.acknowledge_button' | translate"
  (primaryButtonClick)="acknowledge()">
  <ng-template #dialogContent>
    <div
      class="notice-modal-body"
      cdkFocusRegionStart
      tabindex="-1"
      [innerHTML]="'wl.star.notice_modal.body' | translate"></div>
  </ng-template>
</rd-popup-default-template>
